module.exports = __webpack_public_path__ + "img/forum.7a82a7b4.svg";